module.exports = __webpack_public_path__ + "img/nature-31.d84e4534.jpg";